// extracted by mini-css-extract-plugin
export default {"table":"TableComponent_table__kZmit","calculation":"TableComponent_calculation__o4SzP","sum":"TableComponent_sum__OgE6L"};